import React, { useEffect, useState } from "react";
import { Formik, Form, FormikProps } from "formik";
import Select from "react-select";
import Typography from "../../../designComponents/Typography";
import { PropertyAddressType } from "./types";
import Button from "../../../designComponents/Button";
import { AddPropertyProps } from ".";
import requestAPI from "../../../utils/requestAPI";
import properties from "../../../apiConfigs/properties";

const Address: React.FC<AddPropertyProps> = ({
  initialValues,
  onUpdate,
  gotoPrevious,
  errorMessage,
  loading,
}) => {
  const [options, setOptions] = useState<any[]>([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const fetchAddresses = async () => {
      if (inputValue.trim() === "") return;

      try {
        const response = await requestAPI(
          properties.getSearchProperty(inputValue)
        );
        const data = response;
        const formattedOptions = data.map((item: any) => ({
          label: item.description,
          value: item.description,
        }));

        setOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching address suggestions:", error);
      }
    };

    const debounceFetch = setTimeout(() => fetchAddresses(), 300);
    return () => clearTimeout(debounceFetch);
  }, [inputValue]);


  return (
    <div>
      <Typography size="h3" style={{ marginBottom: "10px" }}>
        Step 1: Address
      </Typography>
      <Formik<PropertyAddressType>
        initialValues={{
          address: initialValues.address,
        }}
        enableReinitialize
        onSubmit={(values) => {
          onUpdate(values);
        }}
      >
        {(formikProps: FormikProps<PropertyAddressType>) => (
          <Form>
            <Select
              name="address"
              options={options}
              value={
                options.find(
                  (option) => option.value === formikProps.values.address
                ) || {
                  label: formikProps.values.address,
                  value: formikProps.values.address,
                }
              }
              onInputChange={(value) => setInputValue(value)}
              onChange={(option: any) =>
                formikProps.setFieldValue("address", option.value)
              }
              placeholder="Search Address"
              isLoading={loading}
            />
            {errorMessage && (
              <Typography style={{ color: "red" }}>{errorMessage}</Typography>
            )}
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              <Button
                type="button"
                radius="normal"
                onClick={gotoPrevious}
                isDisabled={loading}
              >
                Previous
              </Button>
              <Button type="submit" radius="normal" isLoading={loading}>
                Next
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Address;
